import { ChangeDetectionStrategy, Component, ElementRef, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { LaunchDialogService } from '@spartacus/storefront';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { BaseAbstractModalComponent, ModalCloseReason } from '../../../../core/modal';
import { CartType } from '../../../../core/model';
import { ActiveCartFacade } from '../../base';

@Component({
  selector: 'py-empty-cart-modal',
  templateUrl: './empty-cart-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class EmptyCartModalComponent extends BaseAbstractModalComponent implements OnInit, OnDestroy {
  cartType: CartType;

  private subscriptions = new Subscription();

  constructor(
    private activeCartService: ActiveCartFacade,
    protected launchDialogService: LaunchDialogService,
    protected el: ElementRef,
    protected renderer: Renderer2
  ) {
    super(el, launchDialogService, renderer);
  }

  ngOnInit(): void {
    this.subscriptions.add(
      this.launchDialogService.data$.pipe(take(1)).subscribe((data: CartType) => {
        this.cartType = data;
      })
    );
  }

  onRemove(): void {
    this.activeCartService.removeAllEntries(this.cartType);
    this.launchDialogService.closeDialog(ModalCloseReason.EMPTY_CART_CONFIRMED);
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
